import { loginByToken } from '@app/api/account';
import { useActions } from '@digital/ui/lib/store';
import Axios from 'axios';
import React from 'react';

interface LoginProps {
  onAuthenticate: (isAuthenticated: boolean) => void;
}

const LoginPortal = ({ onAuthenticate }: LoginProps) => {
  const loadPermissions = useActions(state => state.permission.loadPermissions);
  const params = new URLSearchParams(location.search);
  const token = params.get('idToken');
  const url = params.get('url');
  if (token !== null) localStorage.setItem('idtoken', token);

  loginByToken(token).then(data => {
    const resp = data.data
    if (resp && resp.valid) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('isMRN', resp.isMRN);
      localStorage.setItem('codigoUsuario', resp.codigoUsuario);
      localStorage.setItem('idtoken', resp.access_token);
      localStorage.setItem('expiration', resp.expires_in);
      if (resp.url) {
        localStorage.setItem('url', resp.url);
      } else {
        localStorage.removeItem('url');
      }
      onAuthenticate(true);
      if (resp.isFirstAccess == true) {
        loadPermissions(['dfc2fd92-3024-4641-9219-ea357a4eeeb3']);
        window.location.href = '/primeiroAcesso';
      } else {
        loadPermissions(resp.permissoes);
        window.location.href = url || '/';
      }
    } else {
      window.location.href = url || '/';
    }
  });

  return null;
};

export default LoginPortal;
